import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { User } from '../../../models/user.model';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router, private _permissionService: NgxPermissionsService) {
  }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userData = this.auth.getUserDetails();
    const user = userData as User;

    if (!this.auth.getSessionIsLogin() && (user != null && !user.isRemember)) {
      this.router.navigate(['login']);
    }
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (this._permissionService.getPermissions()) {
      if (sessionStorage['permissions']) {
        const permissions: string[] = JSON.parse(atob(sessionStorage['permissions']));
        this._permissionService.loadPermissions(permissions);
      }
    }
    return true;
  }
}
